module.exports = __webpack_public_path__ + "img/MSP.dc82c4b3.png";